import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { serchSelect } from "@/mixins/index";
import { dataSummary } from "@/api/dataAll/dataSummary";
import { getadvLocation } from "@/api/dataAll/advLocation";
import { giftListShow } from "@/api/dataAll/orderDisplay";
import addLinks from "./components/addLinks";
import clipboard from '@/utils/clipboard';
export default {
  name: "giftListPage",
  components: {
    addLinks: addLinks
  },
  data: function data() {
    return {
      tableTitle: [],
      gameId: "",
      value1: "",
      value2: [],
      searchcountry: [{
        id: '1',
        lable: '触发'
      }, {
        id: '2',
        lable: '购买'
      }],
      total: 0,
      pagrSize: 10,
      addWayConfig: false,
      searchData: {
        page: 1,
        game: "",
        platform: "",
        channel: "",
        pkg: "",
        starttime: "",
        endtime: "",
        advChannel: "",
        advLocation: "",
        state: '' // country:'',

      },
      searchMark: {
        game: "",
        platform: "",
        channel: "",
        pkg: "",
        starttime: "",
        endtime: "",
        ad_channel: "",
        ad_placement: "",
        state: '',
        activation_time: '',
        activation_endtime: '' // country:""

      },
      tableData: [],
      tableLtv: [],
      tableDate: "",
      show: false,
      echarts: false,
      dates: [],
      new_device_num: [],
      new_account_num: [],
      active_account_num: [],
      day_account: [],
      recharge_account_num: [],
      recharge_account_amount: [],
      pay_account_percent: [],
      pay_account_arpu: [],
      pay_account_arppu: [],
      login_account_num: []
    };
  },
  created: function created() {
    var _this = this;

    this.getsearchDate();
    searchgame().then(function (res) {
      _this.searchgames = res.data;
      _this.gameId = res.data.id;
    });
    this.searchMark.activation_time = "";
    this.searchMark.activation_endtime = ""; // this.searchMark.country = ""
    // getCountry().then((res) => {
    //   this.searchcountry = res.data;
    // });

    this.searchMark.state = "";
  },
  methods: {
    getsearchDate: function getsearchDate() {
      var now = new Date(this.$times.zeroTimeZone());
      var year = now.getFullYear();
      var month = (now.getMonth() + 1).toString().length < 2 ? "0" + (now.getMonth() + 1) : now.getMonth() + 1;
      var date = now.getDate().toString().length < 2 ? "0" + now.getDate() : now.getDate();
      var date = year + "-" + month + "-" + date;
      this.value2[0] = date;
      this.value2[1] = date;
    },
    stausChang: function stausChang(id) {
      if (id != "") {
        this.searchMark.state = id;
      } else {
        this.searchMark.state = "";
      }
    },
    searchClick: function searchClick() {
      var _this2 = this;

      if (this.value2 && Array.isArray(this.value2) && this.value2.length > 0) {
        this.searchMark.starttime = this.value2[0];
        this.searchMark.endtime = this.value2[1];
      }

      if (this.value1 && Array.isArray(this.value1) && this.value1.length > 0) {
        this.searchMark.activation_time = this.value1[0];
        this.searchMark.activation_endtime = this.value1[1];
      } else {
        this.searchMark.activation_time = "";
        this.searchMark.activation_endtime = "";
      }

      this.searchMark.kind = 1;
      giftListShow(this.searchMark).then(function (res) {
        _this2.tableData = res.data.data || [];
        _this2.total = res.data.total - 0 || 0;
      });
    },
    handleSource: function handleSource(id, num) {
      var _this3 = this;

      this.addWayConfig = true;
      this.$nextTick(function () {
        _this3.$refs.addWayConfig.init(id, num);
      });
    },
    handleClipboard: function handleClipboard(text, event) {
      clipboard(text, event);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchMark.page = val;
      this.searchData.page = val;
      this.searchClick();
    },
    handleDelete: function handleDelete(id) {
      var _this4 = this;

      this.$confirm("此操作将删除该检测链接, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                deleLinksList({
                  id: id
                }).then(function (res) {
                  _this4.searchClick();
                });

                _this4.$message({
                  type: "success",
                  message: "删除成功!"
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    },
    exportdata: function exportdata() {
      if (this.value2.length > 0) {
        this.searchMark.starttime = this.value2[0];
        this.searchMark.endtime = this.value2[1];
      } else {
        this.searchMark.starttime = "";
        this.searchMark.endtime = "";
      }

      if (this.value1.length > 0) {
        this.searchMark.activation_time = this.value1[0];
        this.searchMark.activation_endtime = this.value1[1];
      }

      if (this.searchMark.game != "" && this.searchMark.game != undefined && this.searchMark.platform != "" && this.searchMark.platform != undefined && this.searchMark.starttime != "" && this.searchMark.starttime != undefined && this.searchMark.endtime != "" && this.searchMark.endtime != undefined) {
        if (process.env.NODE_ENV) {
          window.location.href = process.env.VUE_APP_API + '/apply/export_gift_bag_list' + '?game=' + (this.searchMark.game == "" ? "" : this.searchMark.game == undefined ? "" : this.searchMark.game) + "&" + "platform=" + (this.searchMark.platform == "" ? "" : this.searchMark.platform == undefined ? "" : this.searchMark.platform) + "&" + "starttime=" + this.searchMark.starttime + "&" + "endtime=" + this.searchMark.endtime + "&" + "page=" + this.searchMark.page + "&" + "channel=" + (this.searchMark.channel == "" ? "" : this.searchMark.channel == undefined ? "" : this.searchMark.channel) + "&" + "activation_time=" + this.searchMark.activation_time + "&" + "activation_endtime=" + this.searchMark.activation_endtime + "&pkg=" + (this.searchMark.pkg == "" ? "" : this.searchMark.pkg == undefined ? "" : this.searchMark.pkg) + "&ad_channel=" + (this.searchMark.ad_channel == "" ? "" : this.searchMark.ad_channel == undefined ? "" : this.searchMark.ad_channel) + "&ad_placement=" + (this.searchMark.ad_placement == "" ? "" : this.searchMark.ad_placement == undefined ? "" : this.searchMark.ad_placement) + "&state=" + (this.searchMark.state == "" ? "" : this.searchMark.state == undefined ? "" : this.searchMark.state) + "&kind=" + "1";
        }
      } else {
        this.$message({
          message: "请填完必选项哦"
        });
      }
    }
  }
};